<div class="item-content" [ngClass]="getClassNames()">
    @if (!item.disableIcon) {
        <i [ngClass]="getIconCssClass()"></i>
    }
    <div class="item-content__label">{{item.label}}</div>
</div>